import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SalePerProducerReportRequest } from '../models/sale-per-producer-report-models';

@Injectable({
  providedIn: 'root'
})
export class SalePerProducerReportApi {
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  getSalePerProducerReport(request: SalePerProducerReportRequest) {
    let params = new HttpParams();

    if (request.companyId) {
      params = params.set('CompanyId', request.companyId.toString());
    }
    if (request.storeIds) {
      params = params.set('StoreIds', request.storeIds);
    }
    if (request.departmentIds) {
      params = params.set('DepartmentIds', request.departmentIds);
    }
    if (request.categoryIds) {
      params = params.set('CategoryIds', request.categoryIds);
    }
    if (request.subCategoryIds) {
      params = params.set('SubCategoryIds', request.subCategoryIds);
    }
    if (request.userId) {
      params = params.set('UserId', request.userId.toString());
    }

    let adjustedStartDate = request.startDate;
    if (request.startDate) {
      const inputDate = new Date(request.startDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (inputDate.getTime() === today.getTime()) {
        const previousDay = new Date(inputDate);
        previousDay.setDate(previousDay.getDate() - 1);
        adjustedStartDate = previousDay.toISOString();
      }
    }

    const startDateUTC = adjustedStartDate
      ? new Date(adjustedStartDate).toISOString().slice(0, 19).replace('T', ' ')
      : 'null';
    const endDateUTC = request.endDate
      ? new Date(request.endDate).toISOString().slice(0, 19).replace('T', ' ')
      : 'null';

    if (request.startDate) {
      params = params.set('StartDate', startDateUTC);
    }
    if (request.endDate) {
      params = params.set('EndDate', endDateUTC);
    }
    if (request.productionCycleId) {
      params = params.set(
        'ProductionCycleId',
        request.productionCycleId.toString()
      );
    }

    const url = `${this.baseUrl}Reports/SalePerProducerReport`;
    return this.http.get(url, { params });
  }
}
